const httpAdapter = null;
export {
  httpAdapter as default
};
